export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setSales(state, sales) {
    state.sales = sales;
  }
};
